/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Verification_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to send verification email. Please try again." |
*
* @param {Login_Error_Verification_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_verification_failed = /** @type {((inputs?: Login_Error_Verification_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Verification_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'envoi de l'email de vérification. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Bestätigungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare l'email di verifica. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось отправить письмо с подтверждением. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar el correo electrónico de verificación. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证邮件发送失败，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("確認メールを送信できませんでした。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन ईमेल भेजने में विफलता। कृपया पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao enviar o e-mail de verificação. Tente novamente.")
	return /** @type {LocalizedString} */ ("Failed to send verification email. Please try again.")
});